// Load all symbols and add them to symbols.svg
require.context('~/../symbols', true, /\.svg$/);
